import classNames from 'classnames';
import styles from './index.module.sass';
import { declineWord } from '@/modules/common/helpers/decline-word.helper';
import { warehouseModel } from '@/entities/warehouse';
import { WarehouseTypes } from '@/modules/warehouses/ts';
import { useStore } from 'effector-react';
import { $selectedRecipeStore } from '../../store/recipes.store';

export const RecipeWidget = ({
  variant,
  title,
  weight,
  number,
  temperature,
  natura,
  idk,
  humidity,
  fallingNumber,
  protein,
  gluten,
  price,
  priceAll,
  stepsCount,
}: IRecipeWidget) => {

  const activeWarehouse = useStore($selectedRecipeStore);
  const isWarehouseTypeSleeve = activeWarehouse?.type && Number(activeWarehouse.type) as unknown as WarehouseTypes === warehouseModel.WAREHOUSE_TYPES.sleeve;
  const dataset = [
    {
      label: 'клейковина',
      value: gluten ?? 0,
      sign: '%',
    },
    {
      label: 'влажность',
      value: humidity ?? 0,
      sign: '%',
    },
    {
      label: 'ИДК',
      value: idk ?? 0,
      sign: '',
    },
    {
      label: 'число падения',
      value: fallingNumber ?? 0,
      sign: 'сек',
    },
    {
      label: 'протеин',
      value: protein ?? 0,
      sign: 'кДа',
    },
    {
      label: 'натура',
      value: natura ?? 0,
      sign: 'г/л',
    },
  ];
  return (
    <div
      className={classNames(
        styles.recipeWidget,
        variant === 'profit' && styles.profitWidget,
      )}
    >
      <div className={styles.topInfo}>
        <span className={styles.topInfo__title}>
          {variant === 'profit' && stepsCount
            ? `${stepsCount} ${
                stepsCount % 10 === 1 && stepsCount % 100 !== 11
                  ? 'шаг миксования'
                  : (stepsCount % 10 === 2 ||
                      stepsCount % 10 === 3 ||
                      stepsCount % 10 === 4) &&
                    (stepsCount % 100 < 10 || stepsCount % 100 > 20)
                  ? 'шага миксования'
                  : 'шагов миксования'
              }`
            : title}
        </span>
        <span className={styles.topInfo__weight}>
          Вес{' '}
          <span
            className={classNames(
              styles.topInfo__weight_badge,
              variant === 'profit' && styles.topInfo__weight_badge_profit,
            )}
          >
            {weight} т
          </span>
        </span>
        <span
          className={classNames(
            styles.topInfo__number,
            variant === 'profit' && styles.topInfo__number_profit,
          )}
        >
          {variant === 'profit' ? 'итог' : `${isWarehouseTypeSleeve
          ? declineWord(Number(number), ['рукавов', 'рукав', 'рукава'])
          : declineWord(Number(number), ['объёмов', 'объём', 'объёма'])} `}
          {variant !== 'profit' && (
            <span className={styles.topInfo__temp_badge}>{temperature} °C</span>
          )}
        </span>
        {variant === 'profit' ? (
          <span className={styles.profit__amount}>
            <span>
              выгода{' '}
              <span className={styles.pa}>
                +{price && price?.toLocaleString('RU-ru')} ₽
              </span>
            </span>{' '}
            <span className={styles.pp}>
              {priceAll && priceAll?.toLocaleString('RU-ru')} ₽
            </span>
          </span>
        ) : (
          <span className={styles.topInfo__temp}>
            <span className={styles.price}>
              {' '}
              {price && price?.toLocaleString('RU-ru')} ₽
            </span>
          </span>
        )}
      </div>
      <div className={styles.bottomInfo}>
        {dataset.map(({ label, value, sign }) => (
          <div className={styles.displayDataItem}>
            <span className={styles.label}>{label}</span>
            <span className={styles.value}>{value}</span>

            {sign && <span className={styles.sign}>{sign}</span>}
          </div>
        ))}
      </div>
    </div>
  );
};

interface IRecipeWidget {
  title: string;
  weight: string | number;
  number: string | number;
  temperature: string | number;
  variant?: 'primary' | 'profit';
  natura: string | number;
  idk: string | number;
  humidity: string | number;
  fallingNumber: string | number;
  protein: string | number;
  gluten: string | number;
  price?: number;
  priceAll?: number;
  stepsCount?: number;
}
